<template>
    <div class="flex items-center py-1">
        <feather-icon
            :icon="[isTop() ? 'PlusIcon' : 'MinusIcon']"
            class="p-0 rounded-full text-white text-center h-4 w-4 mr-2"
            :class="[isTop() ? 'bg-pink' : 'bg-blue']"
            svgClasses="h-4 w-4"
        ></feather-icon>
        <span>{{ getName() }}</span>
        <span class="ml-auto text-grey">{{ getReviewCount() }}</span>
    </div>
</template>

<script>
export default {
    props: {
        ship: {
            type: Object,
            required: true
        },
		label: {
			type: String,
			required: true,
		},
    },
    methods: {
        getName() {
            return this.ship.hits_overall[this.label+"_name"];
        },
        getReviewCount() {
            return this.ship.hits_overall[this.label+"_reviews"];
        },
        isTop(){
            return this.label.includes("top");
        }
    },
}
</script>